export enum ConfirmTypeEn {
  WaitingConfirm = 0,
  Confirmed = 1,
  Synced = 2,
  Reject = 3,
  LoadAll = 4,
  Processing = 5
}
